import type { RouteObject } from "react-router"

import { ReportPath, RootPath } from "@/models/route"

import Gresb from "./components/gresb/gresb"
import Gri from "./components/gri/gri"
import { Reporting } from "./components/reporting/reporting"
import { ReportsLayoutRoute } from "./pages/reports-layout-route/reports-layout-route"
import { SigmaReportRoute } from "./pages/sigma-report-route"

export const reportRoutes: RouteObject[] = [
  {
    path: RootPath.Report,
    element: <ReportsLayoutRoute />,
    children: [
      {
        index: true,
        element: <Reporting />,
      },
      {
        path: ReportPath.Gresb,
        element: <Gresb />,
      },
      {
        path: ReportPath.Gri,
        element: <Gri />,
      },
      {
        path: ReportPath.Workbook,
        element: <SigmaReportRoute />,
      },
    ],
  },
]
